import { ContainerModule } from "inversify";
import { InternationalizationService } from "./internationalization.service";
import { LocalizationService } from "./localization.service";
import { Internationalization_Service_DIID, Localization_Service_DIID } from "./translate.types";

export const TranslateModule = new ContainerModule((bind) => {
    bind(Localization_Service_DIID.symbol).to(LocalizationService).inSingletonScope();
    bind(Internationalization_Service_DIID.symbol).to(InternationalizationService).inSingletonScope();
});
